
  import {
    defineComponent,
    ref,
    onMounted,
    computed,
    onBeforeUnmount,
  } from 'vue';
  import { useRouter } from 'vue-router';
  import { setCurrentPageBreadcrumbs } from '@/core/helpers/breadcrumb';
  import { useI18n } from 'vue-i18n/index';
  import { useStore } from 'vuex';
  import { Actions } from '@/store/enums/StoreEnums';
  import { useAbility } from '@casl/vue';
  import Swal from 'sweetalert2/dist/sweetalert2.js';
  import Datatable from '@/components/kt-datatable/KTDatatable.vue';

  export default defineComponent({
    name: 'ads-property-grouping-listing',
    components: {
      Datatable,
    },
    async setup() {
      const { t, te } = useI18n();
      const store = useStore();
      const router = useRouter();
      const { can } = useAbility();

      const translate = (text) => {
        if (te(text)) {
          return t(text);
        } else {
          return text;
        }
      };

      onMounted(async () => {
        setCurrentPageBreadcrumbs(translate('adsPropertyGroupingListing'), [
          translate('ads'),
        ]);
      });

      onBeforeUnmount(() => {
        store.dispatch(Actions.RESET_ADS_PROPERTY_GROUPINGS_STORE);
      });

      await store.dispatch(Actions.GET_ADS_PROPERTY_GROUPINGS);
      console.log(store.getters.adsPropertyGroupingsList);
      const loading = ref(false);
      const tableHeader = ref([
        {
          name: translate('idColumn'),
          key: 'id',
          sortable: true,
        },
        {
          name: translate('titleEn'),
          key: 'titleEn',
          sortable: true,
        },
        {
          name: translate('titleAr'),
          key: 'titleAr',
          sortable: true,
        },
        {
          name: translate('status'),
          key: 'isActive',
          sortable: true,
        },
        {
          name: translate('icon'),
          key: 'icon',
        },
        {
          name: translate('actions'),
          key: 'actions',
        },
      ]);
      const toggleStatusAdsPropertyGrouping = async (adGrouping) => {
        const deletedMessage = adGrouping.isActive
          ? 'confirmInActive'
          : 'confirmActive';
        const result = await Swal.fire({
          title: translate('areYouSureQ'),
          icon: 'warning',
          text: translate(deletedMessage),
          showCancelButton: true,
          buttonsStyling: false,
          confirmButtonText: translate('confirm'),
          cancelButtonText: translate('cancel'),
          customClass: {
            confirmButton: 'btn fw-bold btn-warning',
            cancelButton: 'btn btn-light',
          },
        });

        if (result.value) {
          loading.value = true;
          await store.dispatch(
            Actions.DELETE_ADS_PROPERTY_GROUPING,
            adGrouping.id
          );
          await store.dispatch(Actions.GET_ADS_PROPERTY_GROUPINGS);
          loading.value = false;
          const [errorName] = Object.keys(store.getters.getErrors);
          const error = store.getters.getErrors[errorName];
          if (error) {
            Swal.fire({
              text: translate(error[0]),
              icon: 'error',
              buttonsStyling: false,
              confirmButtonText: translate('tryAgainExcl'),
              customClass: {
                confirmButton: 'btn fw-bold btn-light-danger',
              },
            });
          } else {
            const successMsg = adGrouping.isActive
              ? 'SUCCESSFULLY_INACTIVATED'
              : 'SUCCESSFULLY_ACTIVEATED';
            Swal.fire({
              text: translate(successMsg),
              icon: 'success',
              buttonsStyling: false,
              confirmButtonText: translate('ok'),
              customClass: {
                confirmButton: 'btn btn-light-primary',
              },
            });
          }
        }
      };

      const onTypeChange = async (values) => {
        loading.value = true;
        await store.dispatch(
          Actions.UPDATE_ADS_PROPERTY_GROUPING_CURRENT_PAGE,
          1
        );
        await store.dispatch(Actions.GET_ADS_PROPERTY_GROUPINGS);
        loading.value = false;
        const [errorName] = Object.keys(store.getters.getErrors);
        const error = store.getters.getErrors[errorName];

        if (error) {
          Swal.fire({
            text: translate(error[0]),
            icon: 'error',
            buttonsStyling: false,
            confirmButtonText: translate('tryAgainExcl'),
            customClass: {
              confirmButton: 'btn fw-bold btn-light-danger',
            },
          });
        }
      };
      const onReset = async () => {
        debugger;
        loading.value = true;
        await store.dispatch(
          Actions.UPDATE_ADS_PROPERTY_GROUPING_CURRENT_PAGE,
          1
        );
        await store.dispatch(Actions.GET_ADS_PROPERTY_GROUPINGS);
        loading.value = false;
      };
      const editAdsPropertyGrouping = (id) => {
        router.push({
          name: 'ads-property-grouping-editing',
          params: { id },
        });
      };

      const goTo = (pageName) => {
        router.push({ name: pageName });
      };

      const pageChanged = async (val) => {
        loading.value = true;
        await store.dispatch(
          Actions.UPDATE_ADS_PROPERTY_GROUPING_CURRENT_PAGE,
          val
        );
        await store.dispatch(Actions.GET_ADS_PROPERTY_GROUPINGS);
        loading.value = false;
      };

      store.dispatch(Actions.REMOVE_BODY_CLASSNAME, 'page-loading-over');

      return {
        onTypeChange,
        onReset,
        tableData: computed(() => store.getters.adsPropertyGroupingsList),
        tableHeader,
        toggleStatusAdsPropertyGrouping,
        translate,
        totalItems: computed(() => store.getters.adsPropertyGroupingsListCount),
        pageChanged,
        goTo,
        editAdsPropertyGrouping,
        loading,
        can,
      };
    },
  });
